// Legacy CartMembershipsService entry point — kept ONLY for backwards compatibility.
import angular from 'angular';

// Re-export so existing imports keep working.
export { CartMembershipsService } from '@ng/core/cart/memberships/cart-memberships.service';
export type { CartMembershipsParent } from '@ng/core/cart/memberships/cart-memberships.service';

/**
 * Empty AngularJS module — preserved so `acme.common.service.cart.memberships`
 * keeps resolving. The actual factory is registered in ng-downgraded-components.ts.
 */
export const CartMembershipsServiceModule = angular.module('acme.common.service.cart.memberships', []).name;